module.exports = __webpack_public_path__ + "img/products_big_can_watermelon.e0d41bd7.png";